export const PaidCustomHeroSection: React.FC<{
    customHeroSection: React.ReactNode;
}> = ({
    // eslint-disable-next-line react/prop-types
    customHeroSection
}) => {
    return <>{customHeroSection}</>;
};
PaidCustomHeroSection.displayName = "CustomHero";
